import { useNavigate } from 'react-router-dom';
import styles from './KnowledgeTrailCard.module.css';
import * as routes from '../../../../constants/Routes';
import { useAuth } from '../../../../hooks/useAuth';
import { IKnowledgeTrail } from '../../types';

interface KnowledgeTrailCardProps {
  trail: IKnowledgeTrail;
}

export function KnowledgeTrailCard({ trail }: KnowledgeTrailCardProps) {
  const navigate = useNavigate();
  const { client } = useAuth();

  return (
    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
      <div className={styles.cardReveal}>
        <div
          className={styles.cardBanner}
          style={
            !trail.coverImage
              ? { backgroundColor: client?.primaryColor || '#6b7280' }
              : undefined
          }
        >
          {trail.coverImage ? (
            <img src={trail.coverImage} alt={trail.title} />
          ) : (
            <span className={styles.titleChip}>{trail.title}</span>
          )}
        </div>
        <div className={`${styles.cardTitle} text-truncate px-4 py-3`}>
          <span>{trail.title}</span>
        </div>
        <div className="px-4">
          <div className={styles.details}>
            <span className={styles.badge}>
              {trail.content.length} Conteúdos
            </span>
            <span className={styles.badge}>Performance</span>
          </div>
          <div className={styles.progressWrapper}>
            <div className={styles.progressBar}>
              {trail.content.map((item, i) => (
                <div
                  key={i}
                  className={`${styles.progressSegment} ${
                    item.playerPerformance?.nOfAttempts > 0
                      ? styles.answered
                      : ''
                  }`}
                />
              ))}
            </div>
            <span className={styles.progressLabel}>
              {
                trail.content.filter(
                  (c) => c.playerPerformance?.nOfAttempts > 0
                ).length
              }
              /{trail.content.length}
            </span>
          </div>
        </div>
        <div className={`${styles.cardAction} mt-3`}>
          <button
            className={styles.cta}
            onClick={() =>
              navigate(`${routes.KNOWLEDGE_TRAIL}/${trail.id}`, {
                state: { trail },
              })
            }
          >
            <i className="material-icons-outlined mx-2">add</i>
            <span>Mais detalhes</span>
          </button>
        </div>
      </div>
    </div>
  );
}
